import { Stack, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import { useSearchParams } from "react-router";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import { api } from "../../../api/operationsApi";
import PageContainer from "../../common/PageContainer";
import PageContent from "../../common/PageContent";
import CopilotAgentPanel from "./CopilotAgentPanel";

const CopilotAgentsPage = () => {
  const [searchParams] = useSearchParams();
  // Kept above the panels so switching agent, model or effort keeps it; only New Session clears it.
  const [draft, setDraft] = useState(() => searchParams.get("initialPrompt") ?? "");
  const getAgents = useCallback(() => api.copilotAgents.listAgents(), []);
  const [agents, fetchError] = useFetch(getAgents);

  if (agents === undefined) {
    return <InlineLoader />;
  }

  if (fetchError) {
    logError(fetchError, "[CopilotAgentsPage] listAgents");
    return <DataLoadingFailed />;
  }

  if (agents.length === 0) {
    return (
      <Stack sx={{ alignItems: "center", justifyContent: "center", height: "100%", p: 4 }}>
        <Typography color="textSecondary">No agents available.</Typography>
      </Stack>
    );
  }

  const menuItems = agents.map((a) => ({ name: a.slug, label: a.displayName }));

  return (
    <PageContainer menuItems={menuItems}>
      {agents.map((agent) => (
        <PageContent key={agent.slug} name={agent.slug}>
          <CopilotAgentPanel agent={agent} draft={draft} onDraftChange={setDraft} />
        </PageContent>
      ))}
    </PageContainer>
  );
};

export default CopilotAgentsPage;
